import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { FlowNode, AiSmartData } from '../../types';
import { Icon } from '../Icon';
import { NodeIssueBadge } from './NodeIssueBadge';

function modelShortName(id: string): string {
  const m = id.match(/\/([^\/]+)$/);
  return m ? m[1].replace(/-instruct.*$/, '').replace(/-fast$/, '') : id;
}

function AiSmartNodeImpl({ data, selected, id }: NodeProps<FlowNode>) {
  const d = data as AiSmartData;
  return (
    <div className={`vnode ai ${selected ? 'selected' : ''}`} data-node-id={id}>
      <NodeIssueBadge issues={(d as any).__issues} />
      <Handle type="target" position={Position.Top} id="in" />
      <div className="vnode-head">
        <span className="vnode-lbl">
          <Icon name="sparkle" size={11} variant="gold" />
          AI · think + write
        </span>
      </div>

      <div className="vcard vcard-ai">
        <div className="vcard-ai-head">
          <span className="vcard-ai-icon"><Icon name="sparkle" size={20} variant="gold" /></span>
          <div>
            <b>{d.label}</b>
            <span className="vcard-meta">
              <span className="vcard-ai-model">{modelShortName(d.model)}</span>
              {d.format === 'json' ? <span className="vcard-ai-tag">JSON output</span> : <span className="vcard-ai-tag">Text output</span>}
            </span>
          </div>
        </div>
        <div className="vcard-ai-prompt">
          {d.prompt ? (d.prompt.length > 130 ? d.prompt.slice(0, 127) + '…' : d.prompt) : 'No prompt yet — click to add one'}
        </div>
        {d.storeAs && (
          <div className="vcard-ai-store">
            Stored as <code className="vcard-mtag">{`{{${d.storeAs}}}`}</code>
          </div>
        )}
      </div>

      <Handle type="source" position={Position.Bottom} id="out" />
    </div>
  );
}

export const AiSmartNode = memo(AiSmartNodeImpl);
